import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col justify-between pb-3 invoice-file-upload h-full" }
const _hoisted_2 = { class: "grid grid-cols-2 text-sm font-basier lg:text-base" }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "grid grid-cols-2 gap-4 ord text-sm font-basier lg:text-base" }
const _hoisted_5 = { class: "relative" }
const _hoisted_6 = {
  key: 1,
  class: "text-red absolute"
}

import { reactive, watch, ref, onBeforeMount, watchEffect, toRefs } from 'vue'
import { UiCardText, UiInput, UiFileUpload, UiRemovableFileItem } from '@/components/common/ui'
import { UploadedFileType } from '@/types/partials'
interface IProps {
    error?: boolean
    disableRemove?: boolean
    id: string
    inputValue?: string
    fileName?: string
    filePresent?: boolean
    showInput?: boolean
    fileUploadEnable?: boolean
    fileUploadButtonText?: string
    allowNegativeInvoiceValue?: boolean
}
type Emits = {
    (e: 'fileRemove'): void
    (e: 'filesUpload', files: UploadedFileType[]): void
    (e: 'inputChange', inputValue: string): void
    (e: 'invoiceNumberChange', inputValue: string): void
    (e: 'ksefNumberChange', inputValue: string): void
}

export default /*#__PURE__*/_defineComponent({
  props: {
    error: { type: Boolean, required: false, default: false },
    disableRemove: { type: Boolean, required: false, default: false },
    id: { type: String, required: true, default: '' },
    inputValue: { type: String, required: false, default: '' },
    fileName: { type: String, required: false, default: '' },
    filePresent: { type: Boolean, required: false, default: false },
    showInput: { type: Boolean, required: false, default: true },
    fileUploadEnable: { type: Boolean, required: false, default: true },
    fileUploadButtonText: { type: String, required: false, default: 'Dodaj fakturę' },
    allowNegativeInvoiceValue: { type: Boolean, required: false, default: false }
  },
  emits: ["fileRemove", "filesUpload", "inputChange", "invoiceNumberChange", "ksefNumberChange"],
  setup(__props: any, { emit }: { emit: ({
    (e: 'fileRemove'): void
    (e: 'filesUpload', files: UploadedFileType[]): void
    (e: 'inputChange', inputValue: string): void
    (e: 'invoiceNumberChange', inputValue: string): void
    (e: 'ksefNumberChange', inputValue: string): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { error: boolean, disableRemove: boolean, id: string, inputValue: string, fileName: string, filePresent: boolean, showInput: boolean, fileUploadEnable: boolean, fileUploadButtonText: string, allowNegativeInvoiceValue: boolean }




onBeforeMount(() => {
    currentInputValue.value = props.inputValue
})

const currentInputValue = ref<string>('')
const invoiceNumber = ref<string>('')
const ksefNumber = ref<string>('')
const isKsefActive = ref<boolean>(false)
const buttonProps = reactive({
    primary: true,
    showTooltip: props.filePresent,
    disabled: props.filePresent,
    tooltipMessage: 'Nie można dodać więcej niż jedną fakturę. By dodać nową, usuń poprzednią.',
})
const { showTooltip, disabled, tooltipMessage } = toRefs(buttonProps)

watch([currentInputValue], newValues => {
    emit('inputChange', newValues[0])
})

watch(invoiceNumber, newValues => {
    emit('invoiceNumberChange', newValues)
})

watch(ksefNumber, newValues => {
    isKsefActive.value = newValues.length > 0
    emit('ksefNumberChange', newValues)
})
watchEffect(() => {
    showTooltip.value = props.filePresent || isKsefActive.value
    disabled.value = props.filePresent || isKsefActive.value
    tooltipMessage.value = isKsefActive.value
        ? 'Nie możesz dodać pliku jeżeli jest wpisany numer KSeF.'
        : 'Nie można dodać więcej niż jedną fakturę. By dodać nową, usuń poprzednią.'
})

const onFileUpload = (files: UploadedFileType[]) => {
    emit('filesUpload', files)
}
const onFileRemove = () => {
    emit('fileRemove')
}

return (_ctx: any,_cache: any) => {
  const _component_IconCross = _resolveComponent("IconCross")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(UiCardText), { title: "Plik" }, {
        default: _withCtx(() => [
          (props.filePresent)
            ? (_openBlock(), _createBlock(_unref(UiRemovableFileItem), {
                key: 0,
                name: props.fileName,
                "disable-remove": __props.disableRemove,
                onClick: onFileRemove
              }, null, 8, ["name", "disable-remove"]))
            : (_openBlock(), _createElementBlock("span", _hoisted_3, "Dodaj plik"))
        ]),
        _: 1
      }),
      (props.showInput)
        ? (_openBlock(), _createBlock(_unref(UiCardText), {
            key: 0,
            title: "Wartość faktury brutto"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(UiInput), {
                modelValue: currentInputValue.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((currentInputValue).value = $event)),
                class: "invoice-file-upload__input",
                type: "custom-number",
                "allow-negative": props.allowNegativeInvoiceValue
              }, null, 8, ["modelValue", "allow-negative"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        (__props.fileUploadEnable)
          ? (_openBlock(), _createBlock(_unref(UiFileUpload), {
              key: 0,
              id: props.id,
              "button-props": _unref(buttonProps),
              onFilesUpload: onFileUpload
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(__props.fileUploadButtonText) + " ", 1),
                _createVNode(_component_IconCross, { class: "ml-2" })
              ]),
              _: 1
            }, 8, ["id", "button-props"]))
          : _createCommentVNode("", true),
        (props.error)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, " Dodaj plik "))
          : _createCommentVNode("", true)
      ]),
      (props.showInput)
        ? (_openBlock(), _createBlock(_unref(UiCardText), {
            key: 0,
            class: "col-start-2",
            title: "Numer faktury"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(UiInput), {
                modelValue: invoiceNumber.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((invoiceNumber).value = $event)),
                class: "",
                type: "text",
                "error-message": "sdfsdf"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    (props.showInput)
      ? (_openBlock(), _createBlock(_unref(UiCardText), {
          key: 0,
          class: "col-start-2",
          title: "Numer KseF"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(UiInput), {
              modelValue: ksefNumber.value,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((ksefNumber).value = $event)),
              class: "",
              type: "text",
              "error-message": "sdfsdf",
              disabled: props.filePresent
            }, null, 8, ["modelValue", "disabled"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})